import { FILTER_QUERY_VALUE_TYPES } from '@frontend/api';

import { type SignalWithId } from './queryBuilding';

/**
 * Checks if a signal has any dimensional filters (distance fields)
 */
export const hasDimensionalFilters = (signal: SignalWithId): boolean => {
  return signal.groups.some((group) =>
    group.queries.some((query) =>
      [
        FILTER_QUERY_VALUE_TYPES.DISTANCE,
        FILTER_QUERY_VALUE_TYPES.AREA,
        FILTER_QUERY_VALUE_TYPES.VOLUME,
      ].includes(query.valueType),
    ),
  );
};
